/**
 * Favorite streaming services (matches the legacy app's selector).
 * `id` is the backend service name sent to /favorite-service.
 */
export interface StreamingService {
  id: 'spotify' | 'deezer' | 'apple_music' | 'soundcloud' | 'youtube_music';
  name: string;
}

export const STREAMING_SERVICES: StreamingService[] = [
  { id: 'spotify', name: 'Spotify' },
  { id: 'deezer', name: 'Deezer' },
  { id: 'apple_music', name: 'Apple Music' },
  { id: 'soundcloud', name: 'SoundCloud' },
  { id: 'youtube_music', name: 'YouTube Music' },
];

/** Normalize a service id for comparison (kebab/snake → snake). */
export const normalizeServiceId = (id?: string | null): string =>
  (id ?? '').replace(/-/g, '_').toLowerCase();
